<template>
  <div>
    <el-form label-width="90px">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="订单号">
            <el-input
              v-model="searchForm.orderCode"
              class="cus_width"
              clearable
              placeholder="订单号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="门店" prop="storeId">
            <el-select
              v-model="searchForm.storeId"
              v-loadmore="loadmore"
              :filter-method="filterMethod"
              class="cus_width"
              clearable
              filterable
              placeholder="请选择"
              value-key="id"
            >
              <el-option
                v-for="dict in storeList"
                :key="dict.id"
                :label="dict.name"
                :value="dict.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="仓库" prop="entrepotId">
            <el-select
              v-model="searchForm.entrepotId"
              class="cus_width"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="dict in Entrepotslist"
                :key="dict.id"
                :label="dict.name"
                :value="dict.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商品">
            <el-select
              v-model="searchForm.commodityId"
              class="cus_width"
              clearable
              placeholder="选择商品"
            >
              <el-option
                v-for="(item, index) in goodslist"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="用户名称">
            <el-input
              v-model="searchForm.name"
              class="cus_width"
              clearable
              placeholder="用户名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="下单时间：">
            <el-date-picker
              v-model="tTime"
              :default-time="['00:00:00', '23:59:59']"
              class="cus_width"
              end-placeholder="结束日期"
              format="yyyy年MM月dd日"
              range-separator="至"
              start-placeholder="开始日期"
              type="daterange"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label-width="20px">
            <el-button type="success" @click="getsch">搜索</el-button>
            <el-button type="success" @click="getaglin">重置</el-button>
            <el-button
              type="success"
              @click="getdwon"
              v-if="hasAuth('sys:shipment:export')"
              >导出</el-button
            >
            <el-button
              type="success"
              @click="getfinance"
              v-if="hasAuth('sys:shipment:finance')"
              >财务订单导出</el-button
            >
            <el-button
              type="success"
              @click="getwarehouse"
              v-if="hasAuth('sys:shipment:warehouse')"
              >达人拣货清单导出</el-button
            >
            <el-button
              :disabled="multipleSelection.length > 0 ? false : true"
              type="success"
              @click="printcustom(null, 0)"
              v-if="hasAuth('sys:shipment:manual')"
            >
              手动批量发货
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="tableData"
      border
      element-loading-background="rgba(0, 0, 0, 0.8)"
      element-loading-spinner="el-icon-loading"
      stripe
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        :selectable="selectable"
        align="center"
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        align="center"
        label="订单号"
        prop="orderCode"
        width="200"
      ></el-table-column>

      <el-table-column
        align="center"
        label="订单金额"
        prop="realPayment"
        width="160"
      ></el-table-column>

      <el-table-column
        align="center"
        label="订单状态"
        prop="orderState"
        width="120"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.isPointsCommodity == 1"
            size="small"
            type="success"
            style="margin-bottom: 10px"
            >积分兑换订单
          </el-tag>
          <el-tag
            v-if="scope.row.isLimitedTimeDiscount == 1"
            size="small"
            type="success"
            style="margin-bottom: 10px"
            >秒杀订单
          </el-tag>
          <el-tag
            v-if="scope.row.isGroupBuying == 1"
            size="small"
            type="success"
            style="margin-bottom: 10px"
            >拼团订单
          </el-tag>
          <el-tag
            v-if="scope.row.isCrowdfunding == 1"
            size="small"
            type="success"
            style="margin-bottom: 10px"
            >众筹订单
          </el-tag>
          <el-tag
            v-if="
              scope.row.orderType == 1 &&
              scope.row.isGroupBuyingSuccess == 1 &&
              scope.row.isGroupBuying == 1
            "
            size="small"
            type="success"
            style="margin-bottom: 10px"
            >拼团成功
          </el-tag>
          <el-tag
            v-if="
              scope.row.orderType == 1 &&
              scope.row.isGroupBuyingSuccess == 0 &&
              scope.row.isGroupBuying == 1
            "
            size="small"
            type="success"
            style="margin-bottom: 10px"
            >拼团中
          </el-tag>
          <el-tag v-if="scope.row.orderType == 0" size="small" type="danger"
            >待支付
          </el-tag>
          <el-tag v-if="scope.row.orderType == 1" size="small" type="success"
            >待发货
          </el-tag>
          <el-tag v-if="scope.row.orderType == 2" size="small" type="success"
            >待收货
          </el-tag>
          <el-tag v-if="scope.row.orderType == 3" size="small" type="success"
            >已完成
          </el-tag>
          <el-tag v-if="scope.row.orderType == 4" size="small" type="success"
            >退款中
          </el-tag>
          <el-tag v-if="scope.row.orderType == 5" size="small" type="danger">
            已退款
          </el-tag>
          <el-tag
            v-else-if="scope.row.orderType == 6"
            size="small"
            type="danger"
            >拒绝退款
          </el-tag>
          <el-tag
            v-else-if="scope.row.orderType == 7"
            size="small"
            type="danger"
            >取消订单
          </el-tag>
          <el-tag
            v-else-if="scope.row.orderType == 8"
            size="small"
            type="danger"
            >拼团失败
          </el-tag>
          <el-tag
            v-else-if="scope.row.orderType == 10"
            size="small"
            type="danger"
            >捡货中
          </el-tag>
          <el-tag
            v-else-if="scope.row.orderType == 11"
            size="small"
            type="danger"
            >待取货
          </el-tag>
          <div style="height: 10px"></div>
          <el-tag v-if="scope.row.isPrint == 1" size="small"
            >面单已打印
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="物流"
        prop="comvos"
        width="200"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <div v-if="row.logisticsNumber">{{ row.logisticsNumber }}</div>
          <div v-if="row.logisticsNumbers">{{ row.logisticsNumbers }}</div>
          <div v-if="row.carNum">
            {{ row.carName }}/{{ row.carPhone }}/{{ row.carNum }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="是否异常"
        prop="isException"
        width="120"
      >
        <template slot-scope="{ row }">
          <el-tag v-if="row.isException == 0" type="success">订单正常 </el-tag>
          <el-tag v-if="row.isException == 1" type="danger">订单异常 </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="是否兑换积分"
        prop="isException"
        width="120"
      >
        <template slot-scope="{ row }">
          <el-tag v-if="row.isRedeemPoints == 0" type="success">否 </el-tag>
          <el-tag v-if="row.isRedeemPoints == 1" type="danger">是 </el-tag>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="下单时间"
        prop="payTime"
        width="160"
      ></el-table-column>
      <el-table-column align="center" label="商品名" prop="comvos" width="160">
        <template slot-scope="{ row }">
          <div v-for="(i, o) in row.comvos" :key="o">
            {{ i }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="收货人"
        prop="name"
        width="120"
      ></el-table-column>
      <el-table-column
        align="center"
        label="收货地址"
        prop="address"
        width="260"
      >
        <template slot-scope="{ row }">
          {{ row.province }} - {{ row.city }} - {{ row.county }} -
          {{ row.address }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="归属仓库"
        prop="entrepotName"
        width="140"
      ></el-table-column>
      <el-table-column
        align="center"
        label="是否达人订单"
        prop="storeName"
        width="120"
      >
        <template slot-scope="{ row }">
          {{ row.storeId ? row.storeName : "/" }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="门店展示订单"
        prop="deliveryMethod"
        width="120"
      >
        <template slot-scope="{ row }">
          <el-tag v-if="row.storeShow == 0 && row.storeId" type="success"
            >展示
          </el-tag>
          <el-tag v-if="row.storeShow == 1 && row.storeId" type="danger"
            >隐藏
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="是否开票"
        prop="invoiceState"
        width="120"
      >
        <template slot-scope="{ row }">
          {{
            row.invoiceState == 1
              ? "未开票"
              : row.invoiceState == 2
              ? "已开票"
              : ""
          }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="开票图片"
        prop="invoiceImageUrl"
        width="120"
      >
        <template slot-scope="scope">
          <el-image
            :src="scope.row.invoiceImageUrl"
            :preview-src-list="[scope.row.invoiceImageUrl]"
            v-if="scope.row.invoiceImageUrl"
            fit="scale-down"
            style="width: 70px; height: 70px"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="退款驳回说明"
        prop="result"
        width="160"
      >
      </el-table-column>
      <el-table-column
        align="center"
        fixed="right"
        label="操作"
        prop="icon"
        width="330"
      >
        <template slot-scope="scope">
          <el-button
            v-if="hasAuth('sys:shipment:detail')"
            plain
            style="margin-bottom: 10px"
            type="primary"
            @click="getInfo(scope.row)"
          >
            订单详情
          </el-button>
          <el-button
            v-if="
              scope.row.orderType == 1 &&
              scope.row.isGroupBuyingSuccess == 1 &&
              scope.row.isGroupBuying == 1 &&
              hasAuth('sys:shipment:pttk')
            "
            plain
            style="margin-bottom: 10px"
            type="danger"
            @click="pttuihuo(scope.row)"
            >拼团退款
          </el-button>
          <el-button
            v-if="
              (scope.row.orderType == 1 ||
                scope.row.orderType == 2 ||
                scope.row.orderType == 3 ||
                scope.row.orderType == 11 ||
                scope.row.orderType == 10 ||
                scope.row.orderType == 11 ||
                scope.row.orderType == 9) &&
              hasAuth('sys:shipment:tk')
            "
            plain
            style="margin-bottom: 10px"
            type="danger"
            @click="tuikuan(scope.row)"
            >退款
          </el-button>
          <el-button
            v-if="hasAuth('sys:shipment:fahuo') && userInfo.username != 'admin'"
            plain
            style="margin-bottom: 10px"
            type="primary"
            @click="initwufa(scope.row, 0)"
            >物流发货
          </el-button>
          <el-button
            v-if="
              scope.row.orderType == 1 &&
              hasAuth('sys:shipment:fahuo') &&
              userInfo.username != 'admin'
            "
            plain
            style="margin-bottom: 10px"
            type="warning"
            @click="addsend(scope.row, 1, 0)"
            >货拉拉
          </el-button>
          <el-button
            v-if="
              scope.row.orderType == 1 &&
              hasAuth('sys:shipment:fahuo') &&
              userInfo.username != 'admin'
            "
            plain
            style="margin-bottom: 10px"
            type="warning"
            @click="addsend(scope.row, 2, 0)"
            >手动发货
          </el-button>
          <el-button
            v-if="scope.row.orderType == 1 && hasAuth('sys:shipment:abnormal')"
            plain
            type="danger"
            style="margin-bottom: 10px"
            @click="abnormal(scope.row, 0)"
            >异常处理
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="current"
      :page-size="size"
      :page-sizes="[10, 20, 50, 100]"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></el-pagination>
    <BillDetails
      v-if="BillDetailsvisible"
      ref="BillDetails"
      @refreshDataList="getBill"
    ></BillDetails>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      append-to-body
      class="dialogClass"
      title="填写物流信息"
      width="50%"
    >
      <el-form ref="editForm" class="demo-editForm" label-width="100px">
        <el-form-item v-if="isopt == 2" label="物流单号">
          <el-input
            v-model="logisticsNumbers"
            clearable
            placeholder="请输入物流单号,多个用逗号分隔"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="isopt == 1" label="司机名称">
          <el-input
            v-model="carName"
            clearable
            placeholder="请输入司机名称"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="isopt == 1" label="联系方式">
          <el-input
            v-model="carPhone"
            clearable
            placeholder="请输入联系方式"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="isopt == 1" label="车牌号">
          <el-input
            v-model="carNum"
            clearable
            placeholder="请输入车牌号"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="是否达人订单 "
          label-width="120px"
          v-if="isopt == 1"
        >
          <el-radio-group v-model="isStore">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="isStore == 1 && isopt == 1" label="达人门店ID">
          <el-input
            v-model="storeId"
            clearable
            placeholder="请输入达人门店ID"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <div style="color: red">
            注：请使用同种发货方式，不支持混合发货方式
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="sures">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="pdfVisible"
      append-to-body
      class="dialogClass"
      title="韵达物流面单"
      top="5vh"
      width="50%"
    >
      <iframe
        ref="pdfIframes"
        :src="pdfUrl"
        height="600px"
        width="100%"
      ></iframe>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogCusVisible"
      append-to-body
      class="dialogClass"
      title="填写物流信息"
      width="50%"
    >
      <el-form ref="editForm" class="demo-editForm" label-width="100px">
        <div>
          <el-form-item v-if="isstatus == 0" label="订单号：">
            <el-row :gutter="20">
              <el-col v-for="(i, o) in multipleSelection" :key="o" :span="8">{{
                i.orderCode || ""
              }}</el-col>
            </el-row>
          </el-form-item>
          <el-form-item v-if="isstatus == 1" label="订单号">
            <el-row :gutter="20">
              <el-col
                v-for="(i, o) in multipledetailSelection"
                :key="o"
                :span="8"
                >{{ i.code || "" }}</el-col
              >
            </el-row>
          </el-form-item>
        </div>
        <el-form-item label="物流单号：">
          <el-input
            v-model="logisticsNumbers"
            clearable
            placeholder="请输入物流单号,多个用逗号分隔"
          ></el-input>
        </el-form-item>
        <el-form-item label="司机名称：">
          <el-input
            v-model="carName"
            clearable
            placeholder="请输入司机名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系方式：">
          <el-input
            v-model="carPhone"
            clearable
            placeholder="请输入联系方式"
          ></el-input>
        </el-form-item>
        <el-form-item label="车牌号：">
          <el-input
            v-model="carNum"
            clearable
            placeholder="请输入车牌号"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="是否达人订单 "
          label-width="120px"
          v-if="isopt == 1"
        >
          <el-radio-group v-model="isStore">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="isStore == 1 && isopt == 1" label="达人门店ID">
          <el-input
            v-model="storeId"
            clearable
            placeholder="请输入达人门店ID"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div style="color: red">
            注：请使用同种发货方式，不支持混合发货方式
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="savesubnit">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="wusync"
      append-to-body
      class="dialogClass"
      title="物流"
      width="80%"
    >
      <el-button
        :disabled="multipledetailSelection.length > 0 ? false : true"
        type="success"
        @click="printLogisticsLabel(null, 1)"
      >
        顺丰批量发货
      </el-button>
      <el-button
        :disabled="multipledetailSelection.length > 0 ? false : true"
        type="success"
        @click="printyunda(null, 1)"
      >
        韵达批量发货
      </el-button>
      <el-button
        :disabled="multipledetailSelection.length > 0 ? false : true"
        type="success"
        @click="printcustom(null, 1)"
      >
        手动批量发货
      </el-button>
      <el-button type="success" @click="clbase"> 面单展示打印 </el-button>
      <div style="height: 20px"></div>
      <el-table
        ref="multipledetailTable"
        :data="info"
        border
        stripe
        style="width: 100%"
        tooltip-effect="dark"
        @selection-change="handledetailSelectionChange"
      >
        <el-table-column align="center" type="selection" width="55">
        </el-table-column>
        <el-table-column align="center" label="订单号" prop="code" width="240">
        </el-table-column>
        <el-table-column
          align="center"
          label="商品封面"
          prop="storeGoodsCover"
          width="240"
        >
          <template slot-scope="scope">
            <el-image
              :src="scope.row.cover"
              fit="scale-down"
              style="width: 70px; height: 70px"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="商品名称"
          prop="name"
          width="240"
        ></el-table-column>
        <el-table-column align="center" label="状态" prop="name" width="200">
          <template slot-scope="{ row }">
            {{ row.logisticsTime ? "已发货" : "待发货" }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="物流单号"
          min-width="200"
          prop="logisticsNumber"
        >
          <template slot-scope="{ row }">
            {{
              row.logisticsNumber
                ? row.logisticsNumber
                : row.logisticsNumbers
                ? row.logisticsNumbers
                : row.carNum
                ? row.carName + row.carPhone + row.carNum
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          fixed="right"
          label="操作"
          min-width="240"
          prop="icon"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.pdfInfo"
              plain
              style="margin-bottom: 10px"
              type="primary"
              @click="showmiandan(scope.row.pdfInfo)"
            >
              面单打印
            </el-button>
            <el-button
              v-if="scope.row.orderType == 1"
              plain
              style="margin-bottom: 10px"
              type="primary"
              @click="addsend(scope.row, 2, 1)"
            >
              手动发货
            </el-button>
            <el-button
              v-if="scope.row.orderType == 1"
              plain
              style="margin-bottom: 10px"
              type="primary"
              @click="addsend(scope.row, 1, 1)"
            >
              货拉拉
            </el-button>
            <el-button
              v-if="scope.row.orderType == 1"
              plain
              style="margin-bottom: 10px"
              type="primary"
              @click="printSF(scope.row, 1)"
            >
              顺丰发货
            </el-button>
            <el-button
              v-if="scope.row.orderType == 1"
              plain
              style="margin-bottom: 10px"
              type="primary"
              @click="printYD(scope.row, 1)"
            >
              韵达发货
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogYCVisible"
      append-to-body
      class="dialogClass"
      title="订单异常信息填写"
      width="50%"
    >
      <el-form ref="editForm" class="demo-editForm" label-width="100px">
        <el-form-item label="订单单号：">
          {{ orderCode }}
        </el-form-item>
        <el-form-item label="附件：">
          <VploadImgFour
            :fileData="fileData"
            :fileSize="fileSize"
            :fileType="fileType"
            :limit="10"
            :value="exceptionImg"
            @input="getImgList"
          >
          </VploadImgFour>
        </el-form-item>

        <el-form-item label="异常信息">
          <el-input
            v-model="exceptionMsg"
            clearable
            rows
            type="textarea"
            placeholder="异常信息"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="success" @click="exceptionsubnit">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogTKVisible"
      append-to-body
      class="dialogClass"
      title="订单退款"
      width="50%"
    >
      <el-form ref="editForm" class="demo-editForm" label-width="100px">
        <el-form-item label="订单单号：">
          {{ orderCode }}
        </el-form-item>
        <el-form-item label="退款金额">
          <el-input
            v-model="money"
            clearable
            type="Number"
            :min="0"
            placeholder="退款金额"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="success" @click="Tksubnit">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import ty from "../../utils/ty";
import VploadImgFour from "../inc/VploadImgFour";
import BillDetails from "./details";
import { PDFDocument } from "pdf-lib";
import * as XLSX from "xlsx";
export default {
  name: "shipment",
  components: {
    BillDetails,
    VploadImgFour,
  },
  data() {
    return {
      fileData: {
        type: 0,
        fileType: 0,
      },
      dialogTKVisible: false,
      fileType: ["png", "jpg", "jpeg"],
      fileSize: 5,
      pdfBase64List: [],
      pdfVisible: false,
      money: 0,
      wusync: false,
      dialogCusVisible: false,
      checkedCities: "",
      dialogYCVisible: false,
      searchForm: {
        phone: "",
        endTime: "",
        invoiceState: null,
        orderType: 1,
        storeId: "",
        name: "",
        isGroupBuying: "",
        orderCode: "",
        startTime: "",
        entrepotId: "",
        commodityId: null,
      },
      resultStore: 1,
      pdfUrl: null,
      carPhone: "",
      carName: "",
      carNum: "",
      isStore: 0,
      storeId: "",
      dialogVisible: false,
      checkAll: false,
      delBtlStatu: true,
      tableData: [],
      multipleSelection: [],
      multipledetailSelection: [],
      total: 0,
      size: 10,
      current: 1,
      BillDetailsvisible: false,
      filiale: {
        pageNum: 1,
        pageSize: 99999,
      },
      isopt: 1,
      billList: [],
      logistics: "",
      id: "",
      tTime: [],
      dataList: [],
      isstatus: 0,
      pagedwon: 0,
      loading: false,
      logisticsTrackingNumber: "",
      isIndeterminate: true,
      logisticsNumbers: "",
      inshop: "",
      shoplist: [],
      userInfo: {},
      chooid: null,
      storeList: [],
      commodityNumber: 0,
      Entrepotslist: [],
      goodslist: [],
      painList: [],
      info: [],
      wu_row: {},
      orderCode: "",
      exceptionMsg: "",
      exceptionImg: "",
    };
  },
  created() {
    var routeQuery = this.$route.query;
    if (routeQuery.name) {
      this.searchForm.name = routeQuery.name;
    }

    this.getBill();
    this.getGoods();
    this.filialeLists();
    this.getEntrepots();
    this.getUserInfo();
  },
  directives: {
    loadmore: {
      inserted(el, binding) {
        const dom = el.querySelector(
          ".el-select-dropdown .el-select-dropdown__wrap"
        );
        dom.addEventListener("scroll", function (e) {
          const condition =
            this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (condition) {
            binding.value();
          }
        });
      },
    },
  },
  methods: {
    abnormal(row) {
      this.orderCode = row.orderCode;
      this.exceptionImg = "";
      this.exceptionMsg = null;
      this.dialogYCVisible = true;
    },
    tuikuan(row) {
      this.orderCode = row.orderCode;
      this.resultStore = 1;
      this.result = "";
      this.dialogTKVisible = true;
    },
    Tksubnit() {
      if (this.money == "") {
        this.$message({
          message: "请输入退款金额	",
          type: "warning",
        });
        return;
      }

      this.$axios
        .post("/admin/order/confirmRefundCrawling", {
          orderCode: this.orderCode,
          money: this.money,
        })
        .then((res) => {
          if (res.code != 0) {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
              onClose: () => {},
            });
            return false;
          }
          this.dialogTKVisible = false;
          this.getBill();
          this.$message({
            showClose: true,
            message: "操作成功",
            onClose: () => {},
          });
        });
    },
    getImgList(val) {
      this.exceptionImg = val;
    },

    selectable(row, index) {
      if (
        row.isPrint == 0 ||
        (row.orderType == 1 && row.isGroupBuying == 0) ||
        (row.isGroupBuying == 1 &&
          row.isGroupBuyingSuccess == 1 &&
          row.orderType == 1)
      ) {
        return true;
      } else {
        return false;
      }
    },
    Characters(url) {
      const byteCharacters = atob(url);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      return URL.createObjectURL(blob);
    },
    async mergePDFs() {
      const mergedPdf = await PDFDocument.create();
      for (const blobUrl of this.pdfBase64List) {
        const response = await fetch(blobUrl);
        const blob = await response.blob();
        const arrayBuffer = await blob.arrayBuffer();
        const pdf = await PDFDocument.load(arrayBuffer);
        const copiedPages = await mergedPdf.copyPages(
          pdf,
          pdf.getPageIndices()
        );
        copiedPages.forEach((page) => mergedPdf.addPage(page));
      }
      const mergedPdfBytes = await mergedPdf.save();
      const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });
      this.pdfUrl = URL.createObjectURL(blob);
    },
    showmiandan(row) {
      this.pdfUrl = this.Characters(row);
      this.pdfVisible = true;
    },
    clbase() {
      this.$nextTick(() => {
        this.mergePDFs();
        this.pdfVisible = true;
      });
    },
    MulYDprint() {
      var orarr = JSON.parse(JSON.stringify(this.multipleSelection));
      var newarr = [];
      for (let i = 0; i < orarr.length; i++) {
        if (orarr[i].logisticsNumbers && orarr[i].isPrint == 0) {
          newarr.push(orarr[i].logisticsNumbers);
        }
      }
      this.$nextTick(() => {
        var newArray = newarr.flatMap((item) => item.split(","));
        const loading = this.$loading({
          lock: true,
          text: "物流面单生成中，请等待...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        this.$axios
          .post("/admin/order/yDPrint", {
            mailnoList: newArray,
          })
          .then((inf) => {
            loading.close();
            this.pdfBase64List = [];
            for (let i = 0; i < inf.data.length; i++) {
              this.pdfBase64List.push(
                this.Characters(inf.data[i].data[0].pdfInfo)
              );
            }
            this.$nextTick(() => {
              this.clbase();
            });
          });
      });
    },
    IsYDprint(row) {
      this.$axios
        .post("/admin/order/print", {
          orderCode: row.orderCode,
        })
        .then((res) => {
          if (res.code != 0) {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
              onClose: () => {},
            });
            return false;
          }
          this.getBill();
          this.$message({
            showClose: true,
            message: "操作成功",
            onClose: () => {},
          });
        });
    },
    exceptionsubnit() {
      if (!this.exceptionMsg) {
        this.$message({
          showClose: true,
          message: "请输入异常信息",
          type: "error",
          onClose: () => {},
        });
        return false;
      }
      this.$axios
        .post("/admin/order/orderException", {
          orderCode: this.orderCode,
          exceptionMsg: this.exceptionMsg,
          exceptionImg: this.exceptionImg,
        })
        .then((res) => {
          if (res.code != 0) {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
              onClose: () => {},
            });
            return false;
          }
          this.dialogYCVisible = false;
          this.getBill();
          this.$message({
            showClose: true,
            message: "操作成功",
            onClose: () => {},
          });
        });
    },

    initwufa(row) {
      this.wu_row = row;
      this.$axios
        .post("/admin/order/getOrderDetail", {
          orderCode: row.orderCode,
        })
        .then((res) => {
          this.info = res.data.tcommodityVos;
          this.pdfBase64List = [];
          for (let i = 0; i < res.data.tcommodityVos.length; i++) {
            if (res.data.tcommodityVos[i].pdfInfo) {
              this.pdfBase64List.push(
                this.Characters(res.data.tcommodityVos[i].pdfInfo)
              );
            }
          }
          this.wusync = true;
        });
    },
    pttuihuo(row) {
      this.$confirm("确认将该用户拼团金额进行退款吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios
          .post("/admin/order/groupRefund", {
            orderCode: row.orderCode,
          })
          .then((res) => {
            this.getBill();
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {},
            });
          });
      });
    },
    printcustom(row, status) {
      this.isstatus = status;
      this.dialogCusVisible = true;
    },
    printyunda(row, status) {
      this.printYD(row, status);
    },
    printYD(row, status) {
      var arr = [];
      this.isstatus = status;
      if (row) {
        this.painList = [row];
      } else {
        this.painList =
          this.isstatus == 1
            ? JSON.parse(JSON.stringify(this.multipledetailSelection))
            : JSON.parse(JSON.stringify(this.multipleSelection));
      }
      this.painList.forEach((el) => {
        arr.push(this.isstatus == 1 ? el.code : el.orderCode);
      });
      const loading = this.$loading({
        lock: true,
        text: "物流面单生成中，请等待...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios
        .post("/admin/order/sfDelivery", {
          orderCodeList: arr,
          type: 1,
          state: this.isstatus,
        })
        .then((res) => {
          loading.close();
          this.initwufa(this.wu_row);
          this.getBill();
          this.multipledetailSelection = [];
          this.multipleSelection = [];
          this.painList = [];
          if (res.code != 0) {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
              onClose: () => {},
            });
            return false;
          } else {
            this.pdfBase64List = [];
            for (let i = 0; i < res.data.length; i++) {
              this.pdfBase64List.push(
                this.Characters(res.data[i].data[0].pdfInfo)
              );
            }
            this.$nextTick(() => {
              this.clbase();
            });
          }
        });
    },
    printSF(row, status) {
      this.printLogisticsLabel(row, status);
    },
    async printLogisticsLabel(row, status) {
      const sfCloudPrintObj = new window.SCPPrint({
        sysCode: "EPS-TAIBAI-CORE", // 接入码
        env: "innerSit", //innerProd  正式环境 //innerSit  测试环境
      });
      const printSuccess = () => {
        console.log("打印成功");
      };
      const options = {
        lodopFn: "PREVIEW", //PREVIEW 预览 //PRINT 打印
      };
      this.isstatus = status;
      var arr = [];
      if (row) {
        this.painList = [row];
      } else {
        this.painList =
          this.isstatus == 1
            ? JSON.parse(JSON.stringify(this.multipledetailSelection))
            : JSON.parse(JSON.stringify(this.multipleSelection));
      }
      this.painList.forEach((el) => {
        arr.push(this.isstatus == 1 ? el.code : el.orderCode);
      });
      this.$nextTick(() => {
        this.$axios
          .post("/admin/order/sfDelivery", {
            orderCodeList: arr,
            type: 0,
            state: this.isstatus,
          })
          .then((res) => {
            if (res.code != 0 && res.code != 200) {
              this.$message({
                showClose: true,
                message: res.msg,
                type: "error",
                onClose: () => {},
              });
              return false;
            }
            res.msg = JSON.parse(res.msg);
            sfCloudPrintObj
              .print(res.msg.data, printSuccess, options)
              .then((result) => {
                this.painList = [];
                this.multipleSelection = [];
                this.multipledetailSelection = [];
                this.getBill();
              })
              .catch((err) => {});
          });
      });
    },
    getGoods() {
      this.$axios
        .post("/admin/commodity/getUpperCommodityList", {
          pageNo: 1,
          pageSize: 99,
          type: 0,
        })
        .then((res) => {
          this.goodslist = res.data.records;
        });
    },
    getUserInfo() {
      this.$axios.post("/admin/user/userInfo").then((res) => {
        this.userInfo = res.data;
      });
    },
    loadmore() {
      this.filiale.pageNum++;
      this.filialeLists();
    },
    filterMethod(query) {
      this.filiale.pageNum = 1;
      this.filiale.name = query;
      this.filialeLists();
    },
    getEntrepots() {
      this.$axios.get("/admin/entrepot/getEntrepots", {}).then((res) => {
        this.Entrepotslist = res.data;
      });
    },
    filialeLists() {
      this.$axios
        .post("/admin/store/getStoreList", this.filiale)
        .then((res) => {
          this.storeList = res.data.records;
        });
    },
    radeoCode(i) {
      this.$axios
        .post("/admin/order/updOrderShow", { orderCode: i })
        .then((res) => {
          this.current = 1;
          this.getBill();
        });
    },
    savesubnit() {
      if (!this.carNum && !this.logisticsNumbers) {
        this.$message({
          showClose: true,
          message: "请填写物流单号或者司机信息",
          type: "error",
          onClose: () => {},
        });
        return false;
      }
      if (this.isstatus == 1) {
        var io = this.multipledetailSelection.map((item, index) => {
          return item.code;
        });
      } else {
        var io = this.multipleSelection.map((item, index) => {
          return item.orderCode;
        });
      }
      var obj = {
        orderCode: io,
        logisticsTrackingNumber: this.logisticsTrackingNumber
          ? this.logisticsTrackingNumber
          : null,
        state: this.isstatus,
        carName: this.carName ? this.carName : null,
        logisticsNumbers: this.logisticsNumbers ? this.logisticsNumbers : null,
        carNum: this.carNum ? this.carNum : null,
        carPhone: this.carPhone ? this.carPhone : null,
        storeId: this.storeId,
        isStore: this.isStore,
      };

      this.$axios.post("/admin/order/deliveryList", obj).then((res) => {
        this.dialogCusVisible = false;
        this.getBill();
        if (this.isstatus == 1) {
          this.initwufa(this.wu_row);
        }
        this.$message({
          showClose: true,
          message: "恭喜你，操作成功",
          type: "success",
          onClose: () => {},
        });
        this.orderCode = "";
        this.logisticsNumbers = "";
        this.logisticsTrackingNumber = "";
        this.carName = "";
        this.carNum = "";
        this.carPhone = "";
        this.storeId = "";
        this.isStore = 0;
      });
    },
    sures() {
      if (!this.carNum && this.isopt == 1) {
        this.$message({
          showClose: true,
          message: "请填写车牌号",
          type: "error",
          onClose: () => {},
        });
        return false;
      }
      if (!this.logisticsNumbers && this.isopt == 2) {
        this.$message({
          showClose: true,
          message: "请填写物流单号",
          type: "error",
          onClose: () => {},
        });
        return false;
      }
      var obj = {
        logisticsTrackingNumber: this.logisticsTrackingNumber
          ? this.logisticsTrackingNumber
          : null,
        state: this.isstatus,
        storeId: this.storeId,
        isStore: this.isStore,
        carName: this.carName ? this.carName : null,
        logisticsNumbers: this.logisticsNumbers ? this.logisticsNumbers : null,
        carNum: this.carNum ? this.carNum : null,
        carPhone: this.carPhone ? this.carPhone : null,
      };
      if (this.isstatus == 1) {
        obj.code = this.orderCode;
      } else {
        obj.orderCode = this.orderCode;
      }
      this.$axios.post("/admin/order/delivery", obj).then((res) => {
        this.dialogVisible = false;
        this.getBill();
        if (this.isstatus == 1) {
          this.initwufa(this.wu_row);
        }
        this.$message({
          showClose: true,
          message: "恭喜你，操作成功",
          type: "success",
          onClose: () => {},
        });
        this.orderCode = "";
        this.logisticsNumbers = "";
        this.logisticsTrackingNumber = "";
        this.carName = "";
        this.carNum = "";
        this.storeId = "";
        this.isStore = 0;
        this.carPhone = "";
      });
    },
    getsch() {
      this.current = 1;
      this.getBill();
    },
    getaglin() {
      this.searchForm = {
        phone: "",
        endTime: "",
        orderType: 1,
        name: "",
        orderCode: "",
        startTime: "",
        commodityId: null,
      };
      this.tTime = null;
      this.current = 1;
      this.getBill();
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    selectimetable(row, index) {
      if (row.orderType == 1) {
        return true;
      } else {
        return false;
      }
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handledetailSelectionChange(val) {
      this.multipledetailSelection = val;
    },
    handleSizeChange(val) {
      this.size = val;
      this.getBill();
    },
    handleCurrentChange(val) {
      this.current = val;
      this.getBill();
    },
    getInfo(val) {
      this.BillDetailsvisible = true;
      this.$nextTick(() => {
        this.$refs.BillDetails.init({
            orderCode:val.orderCode,
            storeName:val.storeName
        });
      });
    },
    //获取列表
    getBill() {
      if (this.tTime == null) {
        this.searchForm.startTime = "";
        this.searchForm.endTime = "";
      } else {
        this.searchForm.startTime = this.tTime[0];
        this.searchForm.endTime = this.tTime[1];
      }
      this.searchForm.pageNo = this.current;
      this.searchForm.pageSize = this.size;
      this.$axios
        .post("/admin/order/getOrderList", this.searchForm)
        .then((res) => {
          res.data.records;
          for (var i = 0; i < res.data.records.length; i++) {
            res.data.records[i].comvos =
              res.data.records[i].commodityName.split(",");
          }
          this.$nextTick(() => {
            console.log(res.data.records);
            this.tableData = res.data.records;
            this.total = res.data.total;
          });
        });
    },
    processString(str) {
      // 按逗号分割字符串
      const items = str.split(",");
      // 创建一个空对象来存储每个元素及其出现次数
      const countMap = {};

      // 遍历分割后的元素数组
      for (let i = 0; i < items.length; i++) {
        const item = items[i].trim();
        if (item) {
          if (countMap[item]) {
            // 如果元素已经在对象中，增加其计数
            countMap[item]++;
          } else {
            // 如果元素不在对象中，初始化计数为 1
            countMap[item] = 1;
          }
        }
      }

      // 将对象转换为数组对象
      const result = [];
      for (const key in countMap) {
        result.push({ value: key, count: countMap[key] });
      }

      return result;
    },

    getValSub(val) {
      var items = [
        { pos: val.length - 1, str: "AGhdGAUE6Y" },
        { pos: 38, str: "V22" },
        { pos: 26, str: "Sy" },
        { pos: 18, str: "Hi" },
        { pos: 10, str: "Ti" },
        { pos: 1, str: "Ai" },
      ];

      for (let item of items) {
        if (val.substring(item.pos, item.pos + item.str.length) === item.str) {
          val =
            val.substring(0, item.pos) +
            val.substring(item.pos + item.str.length);
        } else {
          const idx = val.indexOf(item.str);
          if (idx !== -1)
            val = val.substring(0, idx) + val.substring(idx + item.str.length);
        }
      }
      return val;
    },

    getwarehouse() {
      var that = this;
      if (that.tTime == null || that.tTime.length == 0) {
        that.searchForm.startTime = "";
        that.searchForm.endTime = "";
      } else {
        that.searchForm.startTime = that.tTime[0];
        that.searchForm.endTime = that.tTime[1];
      }
      axios({
        method: "post",
        url: ty.apiurl + "/admin/order/warehouseExpertPickingList",
        data: that.searchForm,
        headers: {
          Authorization:that.getValSub(sessionStorage.getItem("token")),
        },
        responseType: "blob",
      })
        .then((res) => {
          const link = document.createElement("a");
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          });
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", "仓库达人拣货清单.xlsx");
          link.click();
          link = null;
        })
        .catch((error) => {});
    },

    getfinance() {
      var that = this;
      if (that.tTime == null || that.tTime.length == 0) {
        that.searchForm.startTime = "";
        that.searchForm.endTime = "";
      } else {
        that.searchForm.startTime = that.tTime[0];
        that.searchForm.endTime = that.tTime[1];
      }
      axios({
        method: "post",
        url: ty.apiurl + "/admin/order/financeExportBillList",
        data: that.searchForm,
        headers: {
          Authorization:that.getValSub(sessionStorage.getItem("token")),
        },
        responseType: "blob",
      })
        .then((res) => {
          const link = document.createElement("a");
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          });
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", "财务订单导出.xlsx");
          link.click();
          link = null;
        })
        .catch((error) => {});
    },
    getdwon() {
      var that = this;
      if (that.tTime == null || that.tTime.length == 0) {
        that.searchForm.startTime = "";
        that.searchForm.endTime = "";
      } else {
        that.searchForm.startTime = that.tTime[0];
        that.searchForm.endTime = that.tTime[1];
      }
      axios({
        method: "post",
        url: ty.apiurl + "/admin/order/exportBillList",
        data: that.searchForm,
        headers: {
          Authorization: that.getValSub(sessionStorage.getItem("token")),
        },
        responseType: "blob",
      })
        .then((res) => {
          const link = document.createElement("a");
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          });
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", "订单列表.xlsx");
          link.click();
          link = null;
        })
        .catch((error) => {});
    },
    addsend(row, type, status) {
      console.log(row);
      var that = this;
      that.isopt = type;
      that.isstatus = status;
      that.dialogVisible = true;
      that.orderCode = status == 1 ? row.code : row.orderCode;
      this.logisticsTrackingNumber = "";
      this.carName = "";
      this.carNum = "";
      this.carPhone = "";
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}

.btnnexts {
  width: 336px;
  height: 48px;
  background: #4293fe;
  border-radius: 24px;
  text-align: center;
  line-height: 48px;
  color: #ffffff;
  margin: 0 auto 20px;
}

.flexjcen {
  display: flex;
  justify-content: space-between;
}

.flexcen {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.bline {
  margin: 10px auto;
}

.bgimg {
  width: 100px;
  height: 100px;
  display: block;
  margin-left: 20px;
  margin-right: 20px;
  border-radius: 10px;
}

.crile {
  border: 1px solid #cccccc;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  box-sizing: border-box;
}

.crilebule {
  border-radius: 50%;
  width: 24px;
  height: 24px;
  background: #4293fe;
}

.namediscount {
  font-size: 16px;
  margin: 10px 0px;
}
</style>
